module.exports = __webpack_public_path__ + "images/emoji/nose.7f62a74da2c94c03b1f2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/nose.png
// module id = K/sa
// module chunks = 14